import React from 'react';
import { Logo } from './Logo';
export function Navbar() {
  return <nav className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-87">
      <div className="max-w-6xl mx-auto px-4 h-20 flex items-center justify-between" data-id="element-88">
        <div className="flex items-center gap-3" data-id="element-89">
          <Logo className="w-8 h-8 text-accent" data-id="element-90" />
          <span className="font-serif text-xl font-bold text-primary" data-id="element-91">
            El Código del Bienestar
          </span>
        </div>
        <a href="#pricing" className="bg-primary text-white px-6 py-2.5 rounded-full font-medium hover:bg-primary/90 transition-colors shadow-sm hover:shadow-md" data-id="element-92">
          Quiero dormir mejor &rarr;
        </a>
      </div>
    </nav>;
}